export default "__VITE_ASSET__CgzGGPUc__"